export enum StatusMinhasComprasList {
    ComprasAnteriores = 0,
    ComprasSalvas = 1,
    ComprasEmAndamento = 2,
    ComprasEmRascunho = 3
}